import { stringify } from 'query-string';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { apiUrl } from '@dashboard/services/env';
import logException from '@dashboard/services/logException';
import request, { fetcher } from '@dashboard/services/request';
import { fetchInfinite } from '@dashboard/services/request';

export const getStripeInvoice = async (chargeId, token) => {
  try {
    const key = `/charges/${chargeId}/stripe-receipt-url`;

    const response = await request(apiUrl + key, token, {
      method: 'GET',
    });

    if (!response.data) {
      const error = new Error(response.message);
      error.response = response;
      throw error;
    }

    return { data: response.data, error: null };
  } catch (error) {
    logException({ message: 'Failed to get invoice PDF', error });

    throw error?.message || 'Failed to get invoice PDF';
  }
};

async function getCharges(sellerId, query, token) {
  const res = await fetcher(`/sellers/${sellerId}/charges?${stringify(query)}`, token);

  return res;
}

async function getInfiniteCharges(sellerId, query, token) {
  const res = await fetchInfinite(`/sellers/${sellerId}/charges?${stringify(query)}`, token);

  return res;
}

async function getInvoicePdf(sellerId, invoiceId, token) {
  const res = await fetcher(`/sellers/${sellerId}/invoices/${invoiceId}/download`, token);

  return res;
}

export default function useChargeQueries() {
  const { sellerId, token } = useAuth();

  return {
    getStripeInvoice: chargeId => getStripeInvoice(chargeId, token),
    getInfiniteCharges: (sellerId, query) => getInfiniteCharges(sellerId, query, token),
    getCharges: (sellerId, query) => getCharges(sellerId, query, token),
    getInvoicePdf: invoiceId => getInvoicePdf(sellerId, invoiceId, token),
  };
}
